// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"322":"e0a17b14","443":"b82ad350","691":"2c05f164","893":"a3e78f0b"}[chunkId] + ".chunk.css";
};